import { MapPin, UserPlus } from 'lucide-react';
import { useStaffDashboard } from '../hooks';
import { DataView } from '../../../components/ui/DataView';
import { Card } from '../../../components/ui/Card';
import { Link } from '@tanstack/react-router';
import type { PeriodOption } from '@repo/shared-dashboard';

interface RecentMembersWidgetProps {
  period?: PeriodOption;
}

export function RecentMembersWidget({ period = 'month' }: RecentMembersWidgetProps) {
  const query = useStaffDashboard(period);

  return (
    <Card className="p-5 flex flex-col justify-between h-full">
      <div className="flex items-center justify-between border-b border-border pb-3 mb-4">
        <h3 className="text-sm font-semibold text-text-primary">Recent Members</h3>
        <Link to="/customers" className="text-xs text-accent-500 font-semibold cursor-pointer hover:underline">
          View All
        </Link>
      </div>
      <DataView query={query} isEmpty={() => false}>
        {(data) => {
          const members = data?.recentMembers ?? [];
          if (members.length === 0) {
            return (
              <div className="py-8 flex flex-col items-center justify-center text-center my-auto">
                <div className="w-10 h-10 rounded-full bg-surface-2 flex items-center justify-center text-text-muted mb-2.5">
                  <UserPlus className="w-5 h-5 opacity-70" />
                </div>
                <p className="text-sm font-semibold text-text-primary">No Recent Members</p>
                <p className="text-xs text-text-muted mt-1 max-w-[220px]">Newly registered members will appear in this list</p>
                <Link to="/customers" className="mt-3 px-3 py-1.5 bg-surface-2 border border-border rounded-[6px] text-xs font-medium text-text-primary hover:bg-surface-3 transition">
                  + Add Member
                </Link>
              </div>
            );
          }

          return (
            <div className="space-y-4">
              {members.map((member) => (
                <div key={member.id} className="flex items-center gap-3">
                  <div className="w-10 h-10 rounded-full bg-surface-2 border border-border text-text-primary flex items-center justify-center font-bold text-sm">
                    {member.name.split(' ').map((n) => n[0]).slice(0, 2).join('')}
                  </div>
                  <div className="flex-1 min-w-0">
                    <p className="text-sm font-semibold text-text-primary truncate">{member.name}</p>
                    <p className="text-xs text-text-secondary flex items-center gap-0.5 truncate">
                      <MapPin className="w-3 h-3 text-text-muted" />
                      {member.branch}
                    </p>
                  </div>
                </div>
              ))}
            </div>
          );
        }}
      </DataView>
    </Card>
  );
}

